module.exports = __webpack_public_path__ + "img/vi.3f317c56.png";